/* @ngInject */
const myWagonTrainSearch = (
  valueHandler,
) => {
  return {
    restrict: 'E',
    scope: {
      myWagon: '=',
      restrictSearch: '=',
    },
    template: require('./myWagonTrainSearch.html'),
    /* @ngInject */
    controller: ($scope) => {
      $scope.currentTrainRadios = [{
        label: 'Train actuel',
        id: 'current',
        value: true,
      }, {
        label: 'Tous les trains',
        id: 'all',
        value: false,
      },]
    },
    link: {
      pre: (scope, element, attrs) => {

        scope.myWagon = scope.myWagon || {}
        scope.myWagon.trainIsCurrent = scope.myWagon.trainIsCurrent || true

        if (valueHandler.isObject(scope.myWagon)) {
          scope.myTrain = {
            tractionnaire: scope.myWagon.trainTractionnaire || null,
            number: scope.myWagon.trainNumber || null,
            arrival: scope.myWagon.trainArrival || null,
            dateBegin: scope.myWagon.trainDateBegin || null,
            dateEnd: scope.myWagon.trainDateEnd || null,
          }
        }
      },
      post: (scope, element, attrs, ctrl) => {
        scope.$watch('myTrain', (newValue, oldValue) => {
          if (newValue !== oldValue) {
            if (valueHandler.isObject(scope.myWagon)) {
              scope.myWagon.trainTractionnaire = scope.myTrain.tractionnaire
              scope.myWagon.trainTractionnaireOperator = scope.myTrain.tractionnaireOperator
              scope.myWagon.trainNumber = scope.myTrain.number
              scope.myWagon.trainNumberOperator = scope.myTrain.numberOperator
              scope.myWagon.trainNumberNull = scope.myTrain.numberNull
              scope.myWagon.trainArrival = scope.myTrain.arrival
              scope.myWagon.trainDateBegin = scope.myTrain.dateBegin
              scope.myWagon.trainDateEnd = scope.myTrain.dateEnd
            }
          }
        }, true)

        scope.$watch('myWagon', (newValue, oldValue) => {
          if (oldValue !== newValue && valueHandler.isObject(newValue)) {
            scope.myTrain = {
              tractionnaire: newValue.trainTractionnaire,
              tractionnaireOperator: newValue.trainTractionnaireOperator,
              number: newValue.trainNumber,
              numberOperator: newValue.trainNumberOperator,
              numberNull: newValue.trainNumberNull,
              dateBegin: newValue.trainDateBegin,
              dateEnd: newValue.trainDateEnd,
              arrival: newValue.trainArrival,
            }

            if (valueHandler.isNull(scope.myWagon.trainIsCurrent)) {
              scope.myWagon.trainIsCurrent = true
            }
          }
        }, true)
      },
    },
  }
}
export default myWagonTrainSearch



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/trains/wagon/directives/search/myWagonTrainSearch.js